export default __webpack_public_path__ + "img/2d0a6729b814b5b28605cfef30d9b0ea.png";